<div class="formHeader">
  Verify or update your personal profile information below.
</div>
<form class="formFieldList" [formGroup]="form" style="width:100%;">
  <div>
    <div>
      <mat-form-field>
          <input matInput placeholder="First Name" formControlName="firstName" required>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <input matInput placeholder="Last Name" formControlName="lastName" required>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <input matInput placeholder="Email Address" formControlName="email" required readonly>
      </mat-form-field>
    </div>
  </div>
</form>